import React, {useRef, useState, useEffect} from 'react'

/**
 * Take Image Component
 *
 * @param onImageDataChange - Callback, what to to when imae change
 * @returns {JSX.Element}
 * @constructor
 */
function TakeImage({onImageDataChange}) {

	let videoRef = useRef(null);

	let photoRef = useRef(null)

	const getVideo = () => {
		navigator.mediaDevices
			.getUserMedia({
				video: true
			})
			.then((stream) => {
				let video = videoRef.current;
				video.srcObject = stream;
				video.play();
			})
			.catch((err) => {
				console.error(err);
			});
	};

	/**
	 * Take picture function
	 */
	const takePicture = () => {
		const width = 400
		const height = width / (16 / 9)

		let video = videoRef.current

		let photo = photoRef.current

		photo.width = width

		photo.height = height

		let ctx = photo.getContext('2d');
		ctx.drawImage(video, 0, 0, width, height)
		onImageDataChange(photo.toDataURL());

	}

	/**
	 * Clear Image
	 */
	const clearImage = () => {
		let photo = photoRef.current

		let ctx = photo.getContext('2d')

		ctx.clearRect(0, 0, photo.width, photo.height)
	}

	useEffect(() => {
		getVideo();
	}, [videoRef]);

	return (
		<div className="">
			<video ref={videoRef} className="container"></video>
			<canvas style={{display: 'none'}} ref={photoRef}></canvas>
			<div className="bottom">
				<div className="prev_next stepper">
					<div id="prev_mobile">
						<button onClick={takePicture} style={{marginRight: '0px'}}
								className="bouton-picto-left goto_backto ">Capturer
						</button>

					</div>
				</div>
			</div>
			<br/><br/>
		</div>
	);

}

export default TakeImage
